
import { TObject } from "../../common/TObject";
import { iData, iDataResult } from "./Data";

export  class Users  extends TObject implements iData{



    crmmap:any = null;
    apicall:string = '/company/users';
    cache:any = false;
    constructor(crmmap) {
        super(crmmap);
        this.crmmap = crmmap;
    }

    getConfig(named:string, userslug: string = null) {
        var vars = userslug?'user='+ encodeURIComponent(userslug) : '';
        return this.crmmap.APICall(`/user/config/${named}?`+vars).then((data) => {
            return data;
        } );
    }

    setConfig(named:string, value:string, userslug: string = null) {
        var postvars = <any> {     };
        postvars['value'] = value;
        if (userslug ) {
            postvars['user'] = userslug;
        }
        
        return  this.crmmap.APICall(`/user/config/${named}`, (d:any) => {
            return d;      
          }, 'POST',postvars); 
    }


    get() {
        return new Promise<iDataResult>((resolve) => {
            if (this.cache) {
                return resolve(this.cache);
            }
        return this.crmmap.APICall(this.apicall).then((data) => {
            this.debug(data);
            this.cache = data;
            this.trigger('refreshed',  this.cache);
            return resolve(this.cache);
        });
    });
    }

    invaledate () {
        this.cache = false;
        this.trigger('invaledate');
    }


    getById(id:number) {
        return this.get().then((d)=>{
            var res = null;
            d.forEach(element => {
                if (element.Userid == id) {
                    res = element;
                }
              
            });
            return res;
        });

    }



}



